import { useEffect, useState } from "react";
import { PoundSterling } from "lucide-react";
import { api } from "@/lib/api";
import { gbp } from "./crmPipelineShared";

const CELLS = [["expected_pipeline", "Expected (pipeline)", "pipeline", "text-emerald-100"], ["earned", "Earned, not invoiced", "earned", "text-brass"],
  ["invoiced_unpaid", "Invoiced, unpaid", "invoiced", "text-blue-200"], ["overdue", "Payment overdue", "overdue", "text-red-300"], ["received", "Cash received", "received", "text-emerald-300"]];

export function FeesSummary() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/crm/fees-summary").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="bg-[#0F2E23] rounded-xl border border-white/10 p-4 mb-5" data-testid="fees-summary">
      <div className="flex items-center gap-2 mb-3"><PoundSterling className="w-4 h-4 text-brass" /><span className="text-sm font-semibold text-white">Auction referral fees</span><span className="text-[11px] text-emerald-100/40 ml-auto">one record per referral, shown everywhere</span></div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {CELLS.map(([k, l, c, tone]) => (
          <div key={k}><div className="text-[11px] text-emerald-100/50">{l}</div><div className={`font-mono text-sm ${tone}`} data-testid={`fees-${k}`}>{gbp(d[k])}</div><div className="text-[10px] text-emerald-100/40">{d.counts[c]} referral{d.counts[c] === 1 ? "" : "s"}</div></div>
        ))}
      </div>
      {d.other_deal_fees > 0 && <div className="text-[11px] text-emerald-100/50 mt-3">Other completed-deal fees (not auction): <span className="text-white font-mono">{gbp(d.other_deal_fees)}</span></div>}
    </div>
  );
}
